import ReactPixel from "react-facebook-pixel";

const STORAGE_KEY = "fired_fb_events";

// Clean up session storage when the module is loaded
if (typeof window !== "undefined") {
  sessionStorage.removeItem(STORAGE_KEY);
}

export const initializeFbPixel = (pixelId) => {
  const options = {
    autoConfig: true,
    debug: false
  };
  ReactPixel.init(pixelId, {}, options);
};

const getEventParams = (eventName, data) => {
  if (eventName === "InitiateCheckout") {
    const { shopifyCart, cartDetails } = data;
    return {
      content_category: "ecommerce",
      content_ids: shopifyCart?.items?.map((item) => item.sku) || [],
      contents:
        shopifyCart?.items?.map((item) => ({
          id: item.sku,
          quantity: item.quantity,
          item_price: item.finalLinePrice
        })) || [],
      currency: cartDetails?.currency || "INR",
      num_items: shopifyCart?.items?.length || 0,
      value: cartDetails?.finalAmount || 0
    };
  }
  if (eventName === "AddPaymentInfo") {
    const { orderDetails } = data;
    return {
      content_category: "ecommerce",
      content_ids: orderDetails?.cart?.items?.map((item) => item.sku) || [],
      contents:
        orderDetails?.cart?.items?.map((item) => ({
          id: item.sku,
          quantity: item.quantity,
          item_price: item.finalLinePrice
        })) || [],
      currency: orderDetails?.currency || "INR",
      value: orderDetails?.finalAmount || 0
    };
  }
  if (eventName === "Purchase") {
    const { orderDetails } = data;
    return {
      content_ids: orderDetails?.cart?.items?.map((item) => item.sku) || [],
      content_type: "product",
      contents:
        orderDetails?.cart?.items?.map((item) => ({
          id: item.sku,
          quantity: item.quantity
        })) || [],
      currency: orderDetails?.currency || "INR",
      num_items: orderDetails?.cart?.items?.length || 0,
      value: orderDetails?.finalAmount || 0
    };
  }
  return null;
};

export const fireFbEvent = (eventName, data) => {
  if (typeof window === "undefined") return undefined;
  if (typeof fbq !== "function") return undefined;
  if (!eventName) return undefined;

  const firedEvents = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
  const eventNameLower = eventName.toLowerCase();

  if (firedEvents.includes(eventNameLower)) return undefined;

  const eventParams = getEventParams(eventName, data);
  if (eventParams) {
    ReactPixel.track(eventName, eventParams);
    firedEvents.push(eventNameLower);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(firedEvents));
  }
  return undefined;
};
